import { AxiosResponse } from 'axios';

import { IGetProductionResponse } from 'models/http/production';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { serverAxios } from '../../http';

class ProductionHttp {
  private static route = '/productions';

  public async checkStatus(id: number, abortController?: AbortController): Promise<IGetProductionResponse> {
    return serverAxios
      .get(`${ProductionHttp.route}/single/${id}/status`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetProductionResponse>) => {
        return response.data;
      });
  }
}

export default ProductionHttp;
